import { InterInstance } from '@api/config';

export const email = async (token: string, quote: any) => {
  try {
    const { data } = await InterInstance({
      method: 'post',
      url: '/mail/quotecs',
      headers: { Authorization: `Bearer ${token}` },
      data: quote,
    });
    return data;
  } catch (e) {
    return e;
  }
};
